import React from 'react';

import { Control, useModal } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { VerificationForm } from './VerificationForm.jsx';

function VerificationWidget(): React.JSX.Element {
  const { t } = useTranslation();
  const verifyModal = useModal();

  return (
    <React.Fragment>
      {verifyModal.wrap(<VerificationForm />)}
      <Control.Button
        className="TaskList__Btn"
        data-testid="verificationButton"
        onClick={verifyModal.open}
      >
        {t('tasks:verification_task')}
      </Control.Button>
    </React.Fragment>
  );
}

export { VerificationWidget };
